import TemplateFrame from "../templateFrame";

function Divider() {
  return (
    <TemplateFrame>
      <hr className="hidden sm:flex h-0.5 border-t-0 bg-gray opacity-100 dark:opacity-50" />
    </TemplateFrame>
  );
}

export default Divider;
